class SettlementHomeController {
    constructor($log) {
        this.$onInit = () => {
            // Nothing yet
        };
        this.testerChange = (tester) => {
            // this.logService.info(tester);
            this.testerId = tester.Id;
            // Get tester stuff
        };
        this.duplicateSearch = (fileId) => {
            this.fileId = fileId;
        };
        this.searchUpdate = () => {
            this.fileId = 0;
        };
        this.fileSelected = (fileId) => {
            this.fileId = fileId;
        };
        this.logService = $log;
    }
}
angular.module('app').component('settlementHome', {
    bindings: {},
    controllerAs: 'vm',
    controller: SettlementHomeController,
    templateUrl: 'scripts/app/partials/settlement/settlement-home.tpl.html'
});
